export const getNavigationPage = (
  page: string,
  jobId: string | null,
  applicationId: string | null
): string => {
  let result = page;
  if (jobId) {
    result = result.replace(':jobId', jobId);
  }

  if (applicationId) {
    result = result.replace(':applicationId', applicationId);
  }

  return result;
};
